var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_9945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 8.24967C2.56284 8.24967 3.26231 8.53941 3.77804 9.05513C4.29376 9.57086 4.5835 10.2703 4.5835 10.9997C4.5835 11.729 4.29376 12.4285 3.77804 12.9442C3.26231 13.4599 2.56284 13.7497 1.8335 13.7497V15.583C1.8335 16.0692 2.02665 16.5356 2.37047 16.8794C2.71428 17.2232 3.1806 17.4163 3.66683 17.4163H18.3335C18.8197 17.4163 19.286 17.2232 19.6299 16.8794C19.9737 16.5356 20.1668 16.0692 20.1668 15.583V13.7497C19.4375 13.7497 18.738 13.4599 18.2223 12.9442C17.7066 12.4285 17.4168 11.729 17.4168 10.9997C17.4168 10.2703 17.7066 9.57086 18.2223 9.05513C18.738 8.53941 19.4375 8.24967 20.1668 8.24967V6.41634C20.1668 5.93011 19.9737 5.4638 19.6299 5.11998C19.286 4.77616 18.8197 4.58301 18.3335 4.58301H3.66683C3.1806 4.58301 2.71428 4.77616 2.37047 5.11998C2.02665 5.4638 1.8335 5.93011 1.8335 6.41634V8.24967Z",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.917 4.58301V6.41634",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.917 15.5825V17.4159",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.917 10.082V11.9154",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_9945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.591af06bc7e24dafb87331adbe0886c8.svg";
export { ForwardRef as ReactComponent };